/**
 * Formatter that applies the given CSS class to either the
 * matched or unmatched portions of a string based on the specified mode.
 */

export const highlightTerm = (
  text: string,
  term: string,
  mode: 'matched' | 'unmatched',
  className: string,
): string => {
  // Escape regex special characters in input
  const escapeRegex = (str: string) =>
    str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  // If term is empty, either highlight everything or return as-is
  if (!term.trim()) {
    return mode === 'unmatched'
      ? `<span class="${className}">${text}</span>`
      : text;
  }

  // Prepare both word-based and combined (no-space) patterns
  const words = term.trim().split(/\s+/).map(escapeRegex);
  const combined = escapeRegex(term.replace(/\s+/g, ''));

  // Match either any word or the combined sequence
  const regex = new RegExp(`(${[...words, combined].join('|')})`, 'gi');

  // Highlight only matched parts
  if (mode === 'matched') {
    return text.replace(regex, `<span class="${className}">$1</span>`);
  }

  // Highlight all unmatched parts
  return text
    .split(regex)
    .map(part =>
      regex.test(part) ? part : `<span class="${className}">${part}</span>`,
    )
    .join('');
};
